import { getFormFieldValue } from "core/form";

import { PAYMENT_TYPE_FIELD, REDEEM_PERIOD_IN_MONTHS_FIELD } from "./constants";

export const getPaymentTypeValue = (formName) => (state) => getFormFieldValue(formName, PAYMENT_TYPE_FIELD)(state);
export const getRedeemPeriodInMonthsValue = (formName) => (state) => getFormFieldValue(formName, REDEEM_PERIOD_IN_MONTHS_FIELD)(state);
